import { useMemo, useState } from "react";
import Joi from "joi-browser";
import { message } from "antd";
import Form from "V2.0/components/Form";
import CopyInput from "V2.0/common/CopyInput";
import { registerInstagram } from "./service";

import InstagramLogo from "V2.0/images/instagram.png";
import { showErrorToast } from "V2.0/utils";

const template = [
  {
    name: "instagramToken",
    label: "Instagram Token",
    type: "text",
    style: "",
  },
  {
    name: "pageID",
    label: "Page ID",
    type: "text",
    style: "",
  },
  {
    name: "fetchPreviousMessages",
    label: "Use Previous Conversations",
    description:
      "Enable this to consider previous conversations while generating response",
    type: "toggle",
  },
];

const schema = {
  instagramToken: Joi.string().max(300).required().label("Instagram Token"),
  pageID: Joi.string().max(50).required().label("pageID"),
  fetchPreviousMessages: Joi.boolean(),
};

const buttonInfo = {
  label: "Connect Instagram",
  style: "entire-width",
};

function Instagram({ workspaceId, fetchInstagramConfiguration, isViewOnly }) {
  const [loading, setLoading] = useState(false);

  const [inputField] = useState({
    instagramToken: "",
    pageID: "",
    fetchPreviousMessages: "",
  });

  const [errorMessage] = useState({});

  const updatedTemplate = useMemo(() => {
    if (!isViewOnly) {
      return template;
    }

    return template.map((field) => {
      return {
        ...field,
        disabled: isViewOnly,
      };
    });
  }, [isViewOnly]);

  const updatedButtonInfo = !isViewOnly ? buttonInfo : {};

  const handleSubmit = async (data) => {
    const payload = {};

    for (let key in data) {
      if (typeof data[key] === "string") {
        payload[key] = data[key].trim();
      } else {
        payload[key] = data[key];
      }
    }
    message.loading("Connecting");

    try {
      const response = await registerInstagram({ workspaceId, payload });

      if (response.status === 200) {
        message.destroy();
        message.success("Instagram Connected");
        setLoading(false);
        fetchInstagramConfiguration(workspaceId);
      }
    } catch (ex) {
      setLoading(false);
      message.destroy();
      showErrorToast(ex, "Failed to connect Instagram");
      return;
    }
  };

  return (
    <div>
      <div className="flex flex-col items-center">
        <div className="w-full max-w-md p-8 border rounded-lg">
          <div className="flex gap-x-2 mb-4">
            <img
              src={InstagramLogo}
              width={24}
            />
            <h3 className="text-base font-semibold leading-6 text-gray-900">
              Connect Instagram
            </h3>
          </div>
          <div>
            <div className="my-5">
              <CopyInput
                value="https://api.apivoicecall.com/api/instagram/webhook"
                title="Instagram Webhook URL"
                type="password"
                disabled
              />
            </div>

            <div className="my-5">
              <CopyInput
                value="4915359cede4b64cb190f02bc1b396af"
                title="Verify token"
                type="password"
                disabled
              />
            </div>
            <div>
              <Form
                key={JSON.stringify(inputField)}
                errorMessage={errorMessage}
                inputField={inputField}
                template={updatedTemplate}
                schema={schema}
                buttonInfo={updatedButtonInfo}
                onSubmit={handleSubmit}
                loading={loading}
                setLoading={setLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Instagram;
